/** @jsxImportSource @emotion/react */
import React from "react";
import { Col, Form, Modal, Row, Button, Select } from "antd";
import { useForm, Controller } from "react-hook-form";
import * as Styles from "./styles";
import { Constant } from "../../../common/constant";

export interface FilterParams {
  keyword?: string;
  role?: string;
}

interface ModalTenantUserFilterProps {
  onCancel: () => void;
  onSearch: (filter: FilterParams) => void;
  visible: boolean;
  filter: FilterParams;
}

const ModalTenantUserFilterComponent: React.FC<ModalTenantUserFilterProps> = ({
  visible,
  onCancel,
  onSearch,
  filter,
}: ModalTenantUserFilterProps) => {
  const { handleSubmit, control, reset } = useForm<FilterParams>({
    mode: "onSubmit",
    defaultValues: filter,
  });

  const handleSubmitHandle = React.useCallback(
    async (data: FilterParams) => {
      const dataObject = data as Record<string, string | undefined>;
      for (const key in data) {
        if (!dataObject[key]) {
          delete dataObject[key];
        }
      }
      onSearch(dataObject as FilterParams);
    },
    [onSearch],
  );

  const onCancelHandle = React.useCallback(() => {
    reset();
    onCancel();
  }, [onCancel, reset]);

  return (
    <Modal
      title="Filter"
      visible={visible}
      closable={false}
      footer={[
        <Button key="back" size="large" onClick={onCancelHandle}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          size="large"
          onClick={handleSubmit(handleSubmitHandle)}
        >
          Search
        </Button>,
      ]}
    >
      <Form layout="vertical" onFinish={handleSubmit(handleSubmitHandle)}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Home Builders" css={Styles.labelStyle}>
              <Controller
                name="role"
                control={control}
                render={({ field }) => (
                  <Select
                    allowClear
                    placeholder="Please select"
                    size="large"
                    {...field}
                  >
                    <Select.Option value={Constant.role.all}>All</Select.Option>
                    <Select.Option value={Constant.role.superModerator}>
                      Super Moderator
                    </Select.Option>
                    <Select.Option value={Constant.role.moderator}>
                      Moderator
                    </Select.Option>
                    <Select.Option value={Constant.role.sale}>
                      Sale
                    </Select.Option>
                  </Select>
                )}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export const ModalTenantUserFilter = React.memo(ModalTenantUserFilterComponent);
